var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Savable } from "@/common/mixins/Savable";
import { Focusable } from "@/common/mixins/Focusable";
import LabelControl from '@/common/components/LabelControl.vue';
import HeaderControl from '@/common/components/HeaderControl.vue';
import ApartmentControl from '@/template/components/investmentReport/controls/ApartmentControl.vue';
var ApartmentAcquisitionsControl = /** @class */ (function (_super) {
    __extends(ApartmentAcquisitionsControl, _super);
    function ApartmentAcquisitionsControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apartmentKey = "";
        return _this;
    }
    Object.defineProperty(ApartmentAcquisitionsControl.prototype, "title", {
        get: function () {
            return "InvestmentReport.Finances.ApartmentAcquisitions.Title";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApartmentAcquisitionsControl.prototype, "title_instructions", {
        get: function () {
            return "InvestmentReport.Finances.ApartmentAcquisitions.Title_Instructions";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApartmentAcquisitionsControl.prototype, "freeOfDebtPrices", {
        get: function () {
            return this.countSum("freeOfDebtPrice");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApartmentAcquisitionsControl.prototype, "transferTaxes", {
        get: function () {
            return this.countSum("transferTax");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApartmentAcquisitionsControl.prototype, "repairCosts", {
        get: function () {
            return this.countSum("repairCosts");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApartmentAcquisitionsControl.prototype, "grandTotal", {
        get: function () {
            return this.countSum("freeOfDebtPrice") + this.countSum("transferTax") + this.countSum("repairCosts");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApartmentAcquisitionsControl.prototype, "duplicateTooltip", {
        get: function () {
            return this.$t("InvestmentReport.Finances.ApartmentAcquisitions.DuplicateApartmentTooltip");
        },
        enumerable: false,
        configurable: true
    });
    ApartmentAcquisitionsControl.prototype.collapseEvent = function (index) {
        if (!this.expandedData || this.expandedData[index] === undefined) {
            this.setExpandedData();
        }
        if (this.expandedData && this.expandedData[index] !== undefined) {
            this.expandedData[index] = !this.expandedData[index];
        }
    };
    ApartmentAcquisitionsControl.prototype.isExpanded = function (index) {
        if (this.expandedData && this.expandedData[index] !== undefined && this.expandedData[index] == false) {
            return false;
        }
        return true;
    };
    ApartmentAcquisitionsControl.prototype.countSum = function (propName) {
        return this.apartments.reduce(function (a, b) {
            var _a;
            return a + ((_a = b[propName]) !== null && _a !== void 0 ? _a : 0);
        }, 0);
    };
    ApartmentAcquisitionsControl.prototype.apartmentTitle = function (apartment, index) {
        var apartmentTitle = "";
        if (apartment.address) {
            if (apartment.address.address) {
                apartmentTitle += apartment.address.address;
                if (apartment.address.city[0]) {
                    apartmentTitle += ", " + apartment.address.city[0].name;
                }
            }
        }
        if (apartmentTitle == "") {
            apartmentTitle = this.$t('InvestmentReport.Finances.ApartmentAcquisitions.HeaderWithIndex', null, [index + 1]).toString();
        }
        return apartmentTitle;
    };
    /**
     * Clone an apartment
     * @param apartment the apartment to clone
     */
    ApartmentAcquisitionsControl.prototype.duplicateApartment = function (apartment) {
        return __awaiter(this, void 0, void 0, function () {
            var index, clone;
            var _this = this;
            return __generator(this, function (_a) {
                index = this.apartments.indexOf(apartment);
                clone = this.cloneApartment(apartment);
                this.apartments.splice(index + 1, 0, clone);
                if (this.expandedData)
                    this.expandedData.splice(index + 1, 0, true);
                this.forceSave();
                this.apartmentKey = Date();
                this.$nextTick().then(function () {
                    var targetId = "apartment-" + (index + 1);
                    _this.focusOnComponentId(targetId);
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Delete an apartment from the list of apartment acquisitions.
     * @param apartment the apartment to remove
     */
    ApartmentAcquisitionsControl.prototype.deleteApartment = function (apartment) {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            return __generator(this, function (_a) {
                if (confirm(this.$i18n.t("Confirmation.DeleteApartment").toString())) {
                    index = this.apartments.indexOf(apartment);
                    this.apartments.splice(index, 1);
                    if (this.expandedData)
                        this.expandedData.splice(index, 1);
                    this.forceSave();
                    this.apartmentKey = Date();
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Creates and adds a new apartment to the list of apartments
     * */
    ApartmentAcquisitionsControl.prototype.create = function () {
        var _this = this;
        var apartment = {
            address: {
                city: []
            }
        };
        this.apartments.push(apartment);
        if (this.expandedData)
            this.expandedData.push(true);
        this.forceSave();
        this.$nextTick().then(function () {
            var targetClass = "apartment-" + (_this.apartments.length - 1);
            _this.focusOnComponentClass(targetClass);
        });
    };
    ApartmentAcquisitionsControl.prototype.cloneApartment = function (apartment) {
        var stringified = JSON.stringify(apartment);
        var parsed = JSON.parse(stringified);
        return parsed;
    };
    ApartmentAcquisitionsControl.prototype.setExpandedData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i;
            return __generator(this, function (_a) {
                this.expandedData = new Array(this.apartments.length);
                for (i = 0; i < this.apartments.length; i++) {
                    this.expandedData[i] = this.$el.getElementsByClassName("collapse")[i].className.indexOf('show') >= 0;
                }
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        Prop({ type: Array, required: true }),
        __metadata("design:type", Array)
    ], ApartmentAcquisitionsControl.prototype, "apartments", void 0);
    ApartmentAcquisitionsControl = __decorate([
        Component({
            name: "ApartmentAcquisitionsControl",
            components: {
                LabelControl: LabelControl,
                HeaderControl: HeaderControl,
                ApartmentControl: ApartmentControl
            }
        })
    ], ApartmentAcquisitionsControl);
    return ApartmentAcquisitionsControl;
}(Mixins(Savable, Focusable)));
export default ApartmentAcquisitionsControl;
